import { Injectable } from '@angular/core';
import {
  ISensorHumedadSuelo,
  ICreateSensorHumedadSuelo,
  IQueryParam,
  IUpdateSensorHumedadSuelo,
  ICliente,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class ShsService {
  constructor(private http: HttpService) {}

  // Shs
  public getShs(id: string): Observable<ISensorHumedadSuelo> {
    return this.http.get(`${api}/shs/${id}`);
  }
  public getShss(queryParams?: IQueryParam): Observable<{
    data: ISensorHumedadSuelo[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/shs`, { params });
  }
  public createShs(
    data: ICreateSensorHumedadSuelo,
  ): Observable<ISensorHumedadSuelo> {
    return this.http.post(`${api}/shs`, data);
  }
  public updateShs(
    id: string,
    data: IUpdateSensorHumedadSuelo,
  ): Observable<ISensorHumedadSuelo> {
    return this.http.put(`${api}/shs/${id}`, data);
  }
  public deleteShs(id: string): Observable<ISensorHumedadSuelo> {
    return this.http.delete(`${api}/shs/${id}`);
  }

  // Reportes

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx',
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(`${api}/reportes/exportar/shs`, filename, params);
  }

  // Parseos

  public estadoShs(dato: ISensorHumedadSuelo) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.ultimaComunicacion
      ? new Date(dato.ultimaComunicacion)
      : null;

    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }

    return dato.ultimoEstado;
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }

  public conseguidorDeColoresPorShs(
    shs: ISensorHumedadSuelo,
    cliente?: ICliente,
  ): string | undefined {
    const tempActual = shs.ultimoReporte?.reporte?.temperatura;

    const semaforos =
      shs?.configuraciones?.coloresNivel ||
      cliente?.configuraciones?.cisterna?.coloresNivel;

    const find = semaforos?.find((semaforo) => {
      return (
        tempActual! >= semaforo.valorDesde && tempActual! < semaforo.valorHasta
      );
    });
    return find?.color;
  }
}
